"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class User extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.recurlySubscriptionId = null;
        this.recurlySubscriptionUuid = null;
        this.organizationId = null;
        this.bot = null;
    }
    schema() {
        return User.schema;
    }
    subject() {
        return User.subject;
    }
}
exports.User = User;
User.subject = "user";
User.schema = {
    "type": "record",
    "name": "User",
    "namespace": "storyblocks.common",
    "fields": [
        {
            "name": "visitorCookieId",
            "type": [
                "null",
                "string"
            ]
        },
        {
            "name": "userId",
            "type": [
                "null",
                "int"
            ]
        },
        {
            "name": "subscriptionId",
            "type": [
                "null",
                "int"
            ]
        },
        {
            "name": "recurlySubscriptionId",
            "type": [
                "null",
                "string"
            ],
            "default": null
        },
        {
            "name": "recurlySubscriptionUuid",
            "type": [
                "null",
                "string"
            ],
            "default": null
        },
        {
            "name": "organizationId",
            "type": [
                "null",
                "int"
            ],
            "default": null
        },
        {
            "name": "bot",
            "type": [
                "null",
                {
                    "type": "record",
                    "name": "Bot",
                    "fields": [
                        {
                            "name": "isBot",
                            "type": "boolean"
                        }
                    ]
                }
            ],
            "default": null
        }
    ]
};
//# sourceMappingURL=User.js.map